import { render } from "./Community.vue?vue&type=template&id=34da8518"
import script from "./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue?vue&type=script&lang=js"
script.render = render

export default script